import { makeAutoObservable } from 'mobx';
import { fetchRegions } from './fn/fetchRegions';
import { Region } from '~/definitions/region';
import { deleteRegions } from './fn/deleteRegions';
import { createRegion } from './fn/createRegion';
import { updateRegionInput } from './fn/updateRegionInput';
import { submitCreateRegion } from './fn/submitCreateRegion';
import { submitDeleteRegions } from './fn/submitDeleteRegions';
import { toggleCheckedRegionId } from './fn/toggleCheckedRegionId';
import { getIsLoading } from './fn/getIsLoading';

export default class RegionStore {
    regions: Region[] = [];
    selectedRegionId: string = '';
    selectedRegionIdForCopy: string = '';

    isLoadingRegions: boolean = false;
    isDeletingRegions: boolean = false;
    isCreatingRegion: boolean = false;

    checkedRegionIds: string[] = [];
    regionName: string = '';
    regionNameError: boolean = false;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.regions = [];
        this.selectedRegionId = '';
        this.selectedRegionIdForCopy = '';

        this.isLoadingRegions = false;
        this.isDeletingRegions = false;
        this.isCreatingRegion = false;

        this.checkedRegionIds = [];
        this.regionName = '';
        this.regionNameError = false;
    }

    get selectedRegion() {
        return this.regions.find((region) => region.id === this.selectedRegionId);
    }

    setRegions = (regions: typeof this.regions) => {
        this.regions = regions;
    };

    setSelectedRegionId = (id: typeof this.selectedRegionId) => {
        this.selectedRegionId = id;
    };

    setSelectedRegionIdForCopy = (id: typeof this.selectedRegionIdForCopy) => {
        this.selectedRegionIdForCopy = id;
    };

    setIsLoadingRegions = (isLoading: typeof this.isLoadingRegions) => {
        this.isLoadingRegions = isLoading;
    };

    setIsDeletingRegions = (isLoading: typeof this.isDeletingRegions) => {
        this.isDeletingRegions = isLoading;
    };

    setiIsCreatingRegion = (isLoading: typeof this.isCreatingRegion) => {
        this.isCreatingRegion = isLoading;
    };

    setRegionName = (name: typeof this.regionName) => {
        this.regionName = name;
    };

    setRegionNameError = (error: typeof this.regionNameError) => {
        this.regionNameError = error;
    };

    setCheckedRegionIds = (ids: typeof this.checkedRegionIds) => {
        this.checkedRegionIds = ids;
    };

    deleteRegions = deleteRegions;
    createRegion = createRegion;
    updateRegionInput = updateRegionInput;
    submitCreateRegion = submitCreateRegion;
    submitDeleteRegions = submitDeleteRegions;
    toggleCheckedRegionId = toggleCheckedRegionId;
    fetchRegions = fetchRegions;
    getIsLoading = getIsLoading;
}
